import styles from './esgLoadingSkeleton.module.scss';

export const EsgLoadingSkeleton = () => (
  <div
    className={styles.esgLoadingSkeleton}
    data-testid='esg-loading-skeleton'
    aria-busy='true'
    aria-label='Loading project ESG data'
  >
    {Array.from({ length: 8 }, (_, sectionIndex) => (
      <section key={sectionIndex} className={styles.section} data-testid='esg-section-skeleton'>
        <div className={styles.heading} aria-hidden='true' />
        <div className={styles.fields}>
          {Array.from({ length: sectionIndex === 0 ? 3 : 2 }, (_, fieldIndex) => (
            <div key={fieldIndex} className={styles.field} data-testid='esg-field-skeleton' aria-hidden='true'>
              <span className={styles.label} />
              <span className={styles.value} />
            </div>
          ))}
        </div>
      </section>
    ))}
  </div>
);
